import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const PURCHASES = [{
  name: 'Sofía',
  city: 'Buenos Aires'
}, {
  name: 'Valentina',
  city: 'Córdoba'
}, {
  name: 'Camila',
  city: 'Rosario'
}, {
  name: 'Martina',
  city: 'Mendoza'
}, {
  name: 'Lucía',
  city: 'La Plata'
}, {
  name: 'María',
  city: 'Mar del Plata'
}, {
  name: 'Julieta',
  city: 'Salta'
}, {
  name: 'Paula',
  city: 'Tucumán'
}, {
  name: 'Ana',
  city: 'Neuquén'
}, {
  name: 'Florencia',
  city: 'Santa Fe'
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      // Pick random person
      const randomPerson = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPerson);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
        // Schedule next appearance (random between 8-15 seconds)
        const nextDelay = Math.floor(Math.random() * 7000) + 8000;
        setTimeout(showNotification, nextDelay);
      }, 4000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-4">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} className="fixed bottom-4 right-4 z-40 bg-white rounded-lg shadow-xl p-4 max-w-xs border-l-4 border-green-500 flex items-center gap-3" data-id="element-5">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-6">
            <CheckCircle className="w-5 h-5 text-green-600" data-id="element-7" />
          </div>
          <div data-id="element-8">
            <p className="text-sm font-medium text-gray-900" data-id="element-9">
              {currentPurchase.name} de {currentPurchase.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-10">
              acaba de comprar este manual
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}